import { Outlet } from 'react-router-dom';
import NavBar from './layout/NavBar';
import Footer from './Footer';
import CookieBanner from './CookieBanner';
import { useLang } from '../utils/i18n';

export default function MainLayout() {
  const { t } = useLang();
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-slate-50 via-gray-50 to-violet-50 dark:from-gray-950 dark:via-gray-900 dark:to-gray-900">
      {/* ── Skip navigation — WCAG 2.4.1 ────────────────────────────────
          First focusable elements in the DOM so keyboard users can jump
          past the nav on every page. Invisible until focused. */}
      <a
        href="#main-content"
        className="
          sr-only focus:not-sr-only
          focus:fixed focus:top-3 focus:left-3 focus:z-[9999]
          focus:px-4 focus:py-2 focus:rounded-lg
          focus:bg-violet-600 focus:text-white focus:font-medium focus:text-sm
          focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-white
        "
      >
        {t('chrome.skipContent')}
      </a>

      {/* ── ARIA live regions — WCAG 4.1.3 ──────────────────────────────
          Persistent, always in the DOM. Updating textContent via the
          useAnnouncer hook triggers screen reader announcements.
          Placed before visible content so they are parsed early. */}
      <div
        id="wheel-announcer"
        role="status"
        aria-live="polite"
        aria-atomic="true"
        aria-relevant="text"
        className="sr-only"
      />
      <div
        id="wheel-announcer-urgent"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        className="sr-only"
      />

      <NavBar />
      <main id="main-content" tabIndex={-1} className="flex-1">
        <Outlet />
      </main>
      <Footer />
      {/* Fixed to the viewport bottom, so it sits above the footer visually
          regardless of scroll position. Not rendered on /embed, which does not
          use MainLayout — that view serves no ads. */}
      <CookieBanner />
    </div>
  );
}
